export default {
  VAULT_REQUEST_OTP_CLICKED: 'Vault Request OTP Clicked',
  VAULT_OTP_LOGIN_ATTEMPTED: 'Vault OTP Login Attempted',
  VAULT_OTP_LOGIN_FAILED: 'Vault OTP Login Failed',
  VAULT_RESEND_OTP_CLICKED: 'Vault Resend OTP Clicked',
  VAULT_OTP_LOGIN_COMPLETED: 'Vault OTP Login Completed',
  VAULT_LOGIN_PAGE_VIEWED: 'Vault Login Page Viewed',
};
